// extracted by mini-css-extract-plugin
export default {"normal":"ContextMenu_normal__5n16m","separator":"ContextMenu_separator__YB2yk"};